































































































































































































































































































import { NullableString } from "@/code/Types";
import { ClientData } from "@/models/ClientData";
import { OpportunityData } from "@/models/OpportunityData";
import { accountStore } from "@/store/modules/AccountStore";
import { clientsStore } from "@/store/modules/ClientStore";
import { opportunityStore } from "@/store/modules/OpportunityStore";
import moment, { Moment } from "moment";
import { Component, Vue } from "vue-property-decorator";
import FileUpload from "@/components/FileUpload.vue";
import { UploadFilesService } from "@/services/UploadFilesService";
import { opportunitiyAttachmentStore } from "@/store/modules/OpportunityAttachmentStore";
import {
  AttachedData,
  OpportunityAttachmentData,
} from "@/models/OpportunityAttachmentData";
import { v4 as uuidv4 } from "uuid";
import { globalStore } from "@/store/modules/GlobalStore";
import { Helpers } from "@/code/Helpers";

@Component({
  components: {
    FileUpload,
  },
})
export default class extends Vue {
  opportunityData!: OpportunityData;
  clientData!: ClientData;
  panel = [0, 1, 2, 3, 4];
  show = false;
  filelist: File[] = [];
  uploadFileService: UploadFilesService = new UploadFilesService();
  componentKey = 0;
  attachments: AttachedData[] = [];
  showSavebutton = false;
  opportunitiyAttachments!: OpportunityAttachmentData;

  created(): void {
    this.opportunityData = opportunityStore.current;
    this.clientData = clientsStore.current;
    this.opportunitiyAttachments = opportunitiyAttachmentStore.current;
    if (this.opportunitiyAttachments.id === null) {
      this.opportunitiyAttachments.id = uuidv4();
      this.opportunitiyAttachments.clientId = this.opportunityData.clientId;
      this.opportunitiyAttachments.opportunityId =
        this.opportunityData.opportunityId;
    }
    this.attachments = this.opportunitiyAttachments.attachments;
    this.attachments.forEach((x) =>
      this.filelist.push(new File([], String(x.documentName)))
    );
  }

  async downloadFile(file: string): Promise<void> {
    const data = await opportunitiyAttachmentStore.downloadFile(
      this.opportunityData.opportunityId,
      file
    );
    const blob = new Blob([data], { type: "application/pdf" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = file;
    link.click();
    URL.revokeObjectURL(link.href);
  }

  get processType(): NullableString {
    return opportunityStore.current.caseId == null
      ? "Case Design"
      : "Underwriting";
  }

  get dateOfBirth(): NullableString {
    return moment(this.clientData.clientDateOfBirth).format("MMMM Do, YYYY");
  }
  get modifiedDate(): NullableString {
    return moment(this.opportunityData.modifiedOn).format("MMMM Do, YYYY");
  }
  get agentName(): NullableString | undefined {
    return accountStore.user?.agentFullName;
  }

  get webNoteOpportunitySubject(): NullableString {
    if (this.opportunityData.webNotesData.length > 0) {
      return this.opportunityData.webNotesData.sort((a, b) => {
        const fa = a.webNotesCreatedDate;
        const fb = b.webNotesCreatedDate;
        if (fa > fb) {
          return -1;
        }
        if (fa < fb) {
          return 1;
        }
        return 0;
      })[0].opportunitySubject;
    }
    return "";
  }

  get webNoteOpportunityNotes(): NullableString {
    if (this.opportunityData.webNotesData.length > 0) {
      return this.opportunityData.webNotesData.sort((a, b) => {
        const fa = a.webNotesCreatedDate;
        const fb = b.webNotesCreatedDate;
        if (fa > fb) {
          return -1;
        }
        if (fa < fb) {
          return 1;
        }
        return 0;
      })[0].opportunityNotes;
    }
    return "";
  }

  get webNotesCreatedDate(): NullableString {
    if (this.opportunityData.webNotesData.length > 0) {
      return this.opportunityData.webNotesData.sort((a, b) => {
        const fa = a.webNotesCreatedDate;
        const fb = b.webNotesCreatedDate;
        if (fa > fb) {
          return -1;
        }
        if (fa < fb) {
          return 1;
        }
        return 0;
      })[0].webNotesCreatedDate;
    }
    return "";
  }
  async updatefilelist(files: File[]): Promise<void> {
    this.showSavebutton = true;
    for (const file of files) {
      const attachmentIndex = this.attachments.findIndex(
        (x) => x.documentName === file.name
      );
      if (attachmentIndex < 0) {
        const attachedData = new AttachedData();
        attachedData.documentName = file.name;
        attachedData.addedOn = null;
        this.attachments.push(attachedData);
        this.componentKey += 1;
      }
      const fileIndex = this.filelist.findIndex((x) => x.name === file.name);

      if (fileIndex < 0) {
        this.filelist = this.filelist.concat(file);
      }
    }
  }

  async deletefilelist(fileName: string): Promise<void> {
    this.attachments = this.attachments.filter(
      (x) => x.documentName !== fileName
    );

    const isFileExist = this.opportunitiyAttachments.attachments.some(
      (x) => x.documentName === fileName && x.addedOn !== null
    );
    if (isFileExist) {
      const filteredData = this.opportunitiyAttachments.attachments.filter(
        (x) => x.documentName !== fileName && x.addedOn !== null
      );
      this.opportunitiyAttachments.attachments = filteredData;
      await this.uploadFileService.remove(
        `${this.opportunityData.opportunityId}/${fileName}`
      );
      await opportunitiyAttachmentStore.save(this.opportunitiyAttachments);
    }

    this.showSavebutton = this.attachments.some((x) => x.addedOn === null);

    this.componentKey += 1;
  }

  showUploadPanel(): void {
    this.show = !this.show;
    this.componentKey += 1;
  }

  async SaveAttachedFiles(): Promise<void> {
    globalStore.setIsBusy(true);
    try {
      await this.uploadFileService.upload(
        this.filelist,
        this.opportunityData.opportunityId
      );
      this.opportunitiyAttachments.attachments = this.attachments;
      this.opportunitiyAttachments.attachments.forEach((x) =>
        x.addedOn === null
          ? (x.addedOn = new Date(moment.utc().format()))
          : x.addedOn
      );
      await opportunitiyAttachmentStore.save(this.opportunitiyAttachments);
      this.showSavebutton = false;
    } catch (err) {
      console.log(err);
    } finally {
      globalStore.setIsBusy(false);
    }
  }

  convertDate(date: Date): Moment {
    return Helpers.convertToEST(date);
  }
}
